<template>
  <div class="common-page-info">
    <div class="top-line">
      <div class="statistic__title-block statistic__page-type"
           @click.stop="openSelect('pageType')">
        <div class="statistic-data-title">Page Type</div>
        <base-select :options="[{ label: 'Remove Page Type', value: '' }, ...pageTypes]"
                     ref="pageType"
                     alignLeft
                     borderLess
                     isNotHighlightOnOpen
                     isGreyArrow
                     showTopBorder
                     :selectStyle="{ height: '16px !important', marginTop: '8px' }"
                     :titleStyle="{ 'font-size': '14px', 'font-weight': 300 }"
                     :propListStyle="{ 'border-top': 'none', 'left': '-10px', minWidth: '160px' }"
                     :propListItemStyle="{ 'width': '120px' }"
                     v-model="content.page_type_id"
                     @change="updateContentBrief('page_type_id', $event)"
                     placeholder="Page Type"/>
      </div>
      <div class="statistic__title-block statistic__section"
           @click.stop="openSelect('section')">
        <div class="statistic-data-title">Section</div>
        <base-select :options="[{ label: 'Remove Section', value: '' }, ...sections]"
                     ref="section"
                     alignLeft
                     borderLess
                     isNotHighlightOnOpen
                     isGreyArrow
                     showTopBorder
                     v-no-options-message="noContributorsMessage"
                     :selectStyle="{ height: '16px !important', marginTop: '8px' }"
                     :titleStyle="{ 'font-size': '14px', 'font-weight': 300 }"
                     :propListStyle="{ 'border-top': 'none', 'left': '-10px', minWidth: '160px' }"
                     :propListItemStyle="{ 'width': '120px' }"
                     v-model="content.section_id"
                     @change="updateContentBrief('section_id', $event)"
                     placeholder="Section"/>
      </div>
      <div class="url">
        <button class="url__button"
          @click="openEditUrlModal">
          <base-material-design-icon class="url__icon"
            icon="edit"/>
          Edit
        </button>
        <a class="url__input" :href="content.published_url || content.url" target="_blank">{{ content.url }}</a>
      </div>
    </div>
    <div class="statistic-holder">
      <div class="statistic">
        <div class="statistic__title-block statistic__url-status"
            @click.stop="emitChangeUrlStatus"
            :class="{'statistic__title-block_clickable': !isCurrentUserClientCollaborator}">
          <div class="statistic-data-title">URL Status</div>
          <div class="statistic-data"
              :class="{'statistic-data_clickable': !isCurrentUserClientCollaborator}">
            <!-- <template v-if="isUrlStatusPublished">
              <a :href="content.url" :title="content.url" target="_blank" @click.stop="()=>{}">Published</a>
            </template> -->
            <template>
              {{urlStatus}}
            </template>
          </div>
        </div>
        <div class="statistic__title-block statistic__title-block_clickable statistic__brief-status"
            @click.stop="$emit('change-status', 'BRIEF_STATUS')">
          <div class="statistic-data-title">Content Brief Status</div>
          <div class="statistic-data statistic-data_clickable">
            {{briefStatus}}
          </div>
        </div>
        <div class="statistic__title-block statistic__strategist"
            @click.stop="openSelect('strategist')">
          <div class="statistic-data-title">Strategist</div>
          <base-select :options="[{ label: 'Remove Strategist', value: -1 }, ...contributorOptions]"
                      ref="strategist"
                      alignLeft
                      borderLess
                      isNotHighlightOnOpen
                      isGreyArrow
                      showTopBorder
                      v-no-options-message="noContributorsMessage"
                      :disabled="isCurrentUserClientCollaborator"
                      :selectStyle="{ height: '16px !important', marginTop: '8px' }"
                      :titleStyle="{ 'font-size': '14px', 'font-weight': 300 }"
                      :propListStyle="{ 'border-top': 'none', 'left': '-10px', minWidth: '160px' }"
                      :propListItemStyle="{ 'width': '120px' }"
                      v-model="content.fk_user_id_strategist"
                      @change="updateContentBrief('fk_user_id_strategist', $event)"
                      placeholder="Strategist"/>
        </div>
        <div class="statistic__title-block statistic__writing-status"
            @click.stop="openSelect('writingStatus')">
          <div class="statistic-data-title">Writing Status</div>
          <base-select :options="writingStatusOptions"
                      ref="writingStatus"
                      alignLeft
                      borderLess
                      isNotHighlightOnOpen
                      isGreyArrow
                      showTopBorder
                      :selectStyle="{ height: '16px !important', marginTop: '8px' }"
                      :titleStyle="{ 'font-size': '14px', 'font-weight': 300 }"
                      :propListStyle="{ 'border-top': 'none', 'left': '-10px' }"
                      :propListItemStyle="{ 'width': '120px' }"
                      v-model="content.writing_status_id"
                      @change="updateWritingStatus"
                      placeholder="Writing Status"/>
        </div>
        <div class="statistic__title-block statistic__editor"
            @click.stop="openSelect('editor')">
          <div class="statistic-data-title">Writer</div>
          <base-select :options="[{ label: 'Remove Writer', value: -1 }, ...contributorOptions]"
                      ref="editor"
                      alignLeft
                      borderLess
                      isNotHighlightOnOpen
                      isGreyArrow
                      showTopBorder
                      v-no-options-message="noContributorsMessage"
                      :disabled="isCurrentUserClientCollaborator"
                      :selectStyle="{ height: '16px !important', marginTop: '8px' }"
                      :titleStyle="{ 'font-size': '14px', 'font-weight': 300 }"
                      :propListStyle="{ 'border-top': 'none', 'left': '-10px', minWidth: '160px' }"
                      :propListItemStyle="{ 'width': '120px' }"
                      v-model="content.fk_user_id_writer"
                      @change="updateContentBrief('fk_user_id_writer', $event)"
                      placeholder="Writer"/>
        </div>
        <div class="statistic__measurement-block first statistic__date">
          <div class="statistic-data-title">Target Date</div>

          <button v-if="targetPublishDate" class="statistic__date-button" @click="openPicker()"
                  :class="{'statistic__date-button_disabled': isCurrentUserClientCollaborator}">
            {{targetPublishDate | formattedDate}}
          </button>
          <base-material-design-icon v-else icon="calendar"
                                    class="statistic__date-button statistic__date-button_icon"
                                    @click="openPicker()"
                                    :class="{'statistic__date-button_highlighted': pickerState.visibility === 'visible',
                                                'statistic__date-button_disabled': isCurrentUserClientCollaborator}">
          </base-material-design-icon>
          <v-date-picker class="statistic__date-picker"
                        ref='picker'
                        value=""
                        :popover="pickerState"
                        @input="setNewDate($event)"
                        :input-props="{
                                      class: 'hidden',
                                      readonly: true
                                    }">
          </v-date-picker>
        </div>
        <div class="statistic__title-block statistic__optimized"
            :class="{'statistic__title-block_clickable': !isCurrentUserClientCollaborator,
              'statistic-data_disabled': isCurrentUserClientCollaborator}"
            @click.stop="$emit('change-status', 'OPTIMIZED_STATUS')">
          <div class="statistic-data-title">Optimized</div>
          <div class="statistic-data statistic-data_clickable">
            {{isOptimized}}
          </div>
        </div>
      </div>
      <div class="statistic">
        <div class="statistic__measurement-block statistic__keywords">
          <div class="statistic-data-title">Keywords</div>
          <div class="statistic-data statistic-data_with-button">
            <template v-if="keywords >= 0">
              <span v-if="isCurrentUserAgent" @click="keywordCensusLink(content.url)" class="link">
                {{ keywords | commaDividedNumber(2) }}
              </span>
              <template v-else>
                {{keywords | commaDividedNumber(2)}}
              </template>
            </template>
            <base-horizontal-loader v-else
              class="statistic-data__loader" />
            <button @click="openNewKeywordsModal()"
              class="statistic-data__button">
              <base-material-design-icon icon="plusBoxOutline"
                class="statistic-data__button-icon" />
            </button>
          </div>
        </div>
        <div class="statistic__measurement-block statistic__searches">
          <div class="statistic-data-title">Monthly Searches</div>
          <div class="statistic-data">{{monthlySearches | commaDividedNumber(2)}}</div>
        </div>
        <div class="statistic__measurement-block statistic__page">
          <div class="statistic-data-title">Page One Coverage</div>
          <div class="statistic-data">{{coverage | commaDividedNumber(2)}}%</div>
        </div>
        <div class="statistic__title-block statistic__url-attributes"
          :class="{'statistic__title-block_clickable': !isCurrentUserClientCollaborator}"
          @click.stop="openUrlAttributes"
        >
          <div class="statistic-data-title">URL Attributes</div>
          <div class="statistic-data">{{urlAttributes | commaDividedNumber(2)}}</div>
        </div>
        <div class="statistic__title-block statistic__created-links">
          <div class="statistic-data-title">Created Links</div>
          <div class="statistic-data">
            <template v-if="content.links_count && !isCurrentUserClientCollaborator">
              <a :href="generateUrl" target="_blank">{{linksCount}}</a>
            </template>
            <template v-else>
              {{linksCount}}
            </template>
          </div>
        </div>
        <div class="statistic__title-block statistic__attachments statistic__title-block_clickable"
          @click.stop="openAttachments"
        >
          <div class="statistic-data-title">Attachments</div>
          <div class="statistic-data">{{content.attachements.length | commaDividedNumber(2)}}</div>
        </div>
      </div>
    </div>
    <modal name="new-keywords-modal" v-bind="modalProps" >
      <new-keyword-discovery-modal :preselectedUrl="urlData" 
        :lockUrlField="true" 
        @close="$modal.hide('new-keywords-modal')"
        @keywords-changed="handleKeywordsChange()"
      />
     </modal>
     <modal name="edit-url" v-bind="modalProps">
      <EditUrlModal :url="content.url"
        :published-url="content.published_url"
        @close="closeEditUrlModal"
        @apply="updateUrl" 
      />
    </modal>
  </div>
</template>

<script>
import filters from '@/common/Filters'
import _ from 'lodash'
import { mapActions } from 'vuex'
import baseModalProps from '@/common/BaseModalProps'
import NewKeywordDiscoveryModal from '../../keyword-census/NewKeywordDiscoveryModal.vue'
import EditUrlModal from './EditUrlModal'

/**
 * Info panel at the top of content brief content page
 */
export default {
  name: 'CommonPageInfo',
  components: {
    NewKeywordDiscoveryModal,
    EditUrlModal
  },
  props: {
    isNewPage: Boolean,
    content: {
      type: Object,
      required: true
    },
    writingStatusOptions: {
      type: Array,
      required: true
    },
    contributorOptions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      pickerState: {
        visibility: 'focus'
      },
      noContributorsMessage: 'This client doesn\'t contain any contributors',
      isDatePickerOpened: false,
      modalProps: { ...baseModalProps, width: 850 }
    }
  },
  created () {
    // we need it for handling date picker popup manually
    const clickHandler = function (event) {
      if (!this.isDatePickerOpened) {
        return
      }
      const classList = Array.from(_.get(event, 'target.classList', []))
      const insideDatePicker = classList.some(className => className.startsWith('vc-'))
      if (insideDatePicker) {
        return
      }
      this.pickerState.visibility = 'focus'
      this.isDatePickerOpened = false
    }
    const handler = clickHandler.bind(this)
    document.addEventListener('click', handler)
    this.contributorOptions = this.contributorOptions.map(contributor => ({...contributor, attributes: [{'private-content': true}] }))
  },
  computed: {
    briefStatus () {
      return this.content.content_brief_status
    },
    generateUrl () {
      let path = `${window.location.origin}${window.location.pathname}#/reports/link-building?contentBrief=`
      path += JSON.stringify({ id: this.content._id, name: this.content.name })
      path = encodeURI(path)
      return path
    },
    KWCLink () {
      return `${window.origin}/dashboard#/strategy/keyword-census?url=${this.content.url}&clientId=${this.clientId}`
    },
    urlStatus () {
      return this.content.url_status
    },
    isUrlStatusPublished () {
      return this.content.url_status.toLowerCase() === 'published'
    },
    monthlySearches () {
      return this.content.metrics.monthly_search_volume
    },
    targetPublishDate () {
      return this.content.target_publish_date
    },
    isOptimized () {
      return this.content.is_optimized ? 'Yes' : 'No'
    },
    linksCount () {
      return this.content.links_count
    },
    keywords () {
      return this.content.metrics.keyword_count
    },
    urlAttributes () {
      return this.content.url_attributes ?? 0
    },
    coverage () {
      return this.content.metrics.first_page_coverage
    },
    urlData() {
      return {
        url: this.content.url,
        urlId: this.content.url_id
      }
    },
    pageTypes() {
      if (!this.content || !this.content.page_types) {
        return []
      }

      return this.content.page_types.map(({ id, name }) => ({
        label: name,
        value: id
      }))
    },
    sections() {
      if (!this.content || !this.content.sections) {
        return []
      }

      return this.content.sections.map(({ id, name }) => ({
        label: name,
        value: id
      }))
    },
  },
  methods: {
    ...mapActions('keywordCensus', ['postTableView']),
    openPicker () {
      let handler = () => {
        this.$set(this.pickerState, 'visibility', 'visible')
        this.isDatePickerOpened = true
        this.$nextTick(this.addClearButton)
      }
      handler = handler.bind(this)
      setTimeout(handler, 100)
    },
    openUrlAttributes () {
      if (this.isCurrentUserClientCollaborator) {
        return
      }
      this.$emit('urlAttributes')
    },
    async keywordCensusLink (url) {
      const form = {
        'filters': [{
          'field': 'url',
          'type': '=',
          'value': url
        }]
      }
      const data = await this.postTableView({ form: form, clientId: this.clientId, type: 'keyword_census' })
      const routeData = this.$router.resolve({ path: `/strategy/keyword-census/${data.data}` });
      window.open(routeData.href, '_blank');
    },
    setNewDate (date) {
      this.pickerState.visibility = 'focus'
      this.$emit('select-date', date)
    },
    clearDateListener () {
      this.pickerState.visibility = 'focus'
      this.$emit('select-date', 'clear')
    },
    updateWritingStatus (statusId) {
      this.$emit('changeWritingStatus', {
        url_id: this.content.url_id,
        writing_status: statusId,
        raiseError: false
      })
    },
    updateContentBrief (key, id) {
      this.$emit('changeContentBrief', { key, id })
    },
    openSelect (ref) {
      this.$refs[ref].open()
    },
    emitChangeUrlStatus () {
      if (!this.isCurrentUserClientCollaborator) {
        this.$emit('change-status', 'URL_STATUS')
      }
    },
    openAttachments() {
      this.$emit('attachments')
    },
    openNewKeywordsModal() {
      this.$modal.show('new-keywords-modal')
    },
    handleKeywordsChange() {
      this.$emit('keywords-changed')
    },
    openEditUrlModal() {
      this.$modal.show('edit-url')
    },
    closeEditUrlModal() {
      this.$modal.hide('edit-url')
    },
    updateUrl(newUrl, newPublishedUrl) {
      this.$emit('url-changed', newUrl, newPublishedUrl)
    }
  },
  filters: {
    ...filters
  }
}
</script>
<style scoped lang="scss">
  .common-page-info {
    padding-top: 5px;
    min-width: 970px;
  }

  .top-line {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 15px;

    .url {
      display: flex;
      align-items: center;
      gap: 10px;
      flex: 1 1;
      padding-top: 20px;
      font-weight: 300;

      &__button {
        display: flex;
        align-items: center;
        gap: 2px;
        border: none;
        outline: none;
        padding: 0;
        background-color: transparent;
        font-size: 14px;
        text-transform: lowercase;
        font-weight: inherit;

        &:hover {
          color: $rfx-bright-blue;
        }
      }

      &__icon {
        font-size: inherit;
        color: inherit;
      }

      &__input {
        text-decoration: none;
        color: $rfx-link-color;
        background-color: transparent;
        flex: 1 1 100%;
        border: none;
        outline: none;
        height: 16px;
        line-height: 16px;
        padding: 4px 10px; 
        font-weight: inherit;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }

  .statistic-holder {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }
  .link {
    cursor: pointer;
    color: $rfx-bright-blue !important;

    &:hover {
      text-decoration: underline;
    }
  }
  .url {
    &__title {
      font-size: 12px;
      font-weight: 500;
      color: $rfx-dark-march;
    }
  }

  .statistic {
    display: flex;
    align-items: center;
    // background: #fff;
    // padding: 10px;
    gap: 15px;
    flex: 1 0;

    &__url-status {
    }

    &__created-links,
    &__editor {
      // margin-right: 24px !important;
    }

    &__brief-status {
    }

    &__strategist,
    &__editor,
    &__writing-status,
    &__page-type,
    &__section {
      overflow: visible !important;

      &::v-deep .select__placeholder {
        padding-left: 0;
        font-size: 14px;
        line-height: 16px;
        font-weight: 300;
      }
    }

    &__date {
      // margin-right: 18px !important;
    }

    &__searches {
    }

    &__keywords {
      flex-basis: 200px;
    }

    &__url-attributes {
      cursor: pointer;
    }

    &__optimized {
      margin-right: 14px !important;
    }

    &__page {
      border-radius: 0 4px 4px 0;
      flex-basis: 200px;
    }

    &__measurement-block {
      position: relative;
      flex: 1;
      max-width: 20%;
      margin-right: 16px;
      box-sizing: border-box;
      font-weight: 500;
      color: #fff;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      -webkit-print-color-adjust: exact;
      white-space: nowrap;
      flex-grow: 0;
      flex-shrink: 0;
    }

    &__title-block {
      border-radius: 4px;
      flex: 1;
      margin-right: 16px;
      background-color: transparent;
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      flex-shrink: 0;

      &_clickable {
        cursor: pointer;
        margin: -5px;
        padding: 5px;

        &:hover {
          background-color: $rfx-light-grey;
        }
      }
    }

    &-data {
      font-size: 14px;
      line-height: 16px;
      min-height: 16px;
      font-weight: 300;
      margin-top: 8px;
      color: $rfx-dark-march;
      white-space: nowrap;

      &_clickable {
        cursor: pointer;
      }

      &_disabled {
        cursor: default;
        pointer-events: none;
      }

      &_with-button {
        display: flex;
        align-items: center;
        margin-top: 2px;
      }

      &__loader {
        transform: scale(.3);
        margin: -22px;
      }

      &__button {
        border: none;
        outline: none;
        background: none;
        height: 22px;

        &:hover {
          color: $rfx-bright-blue;
        }
      }

      &__button-icon {
        color: inherit;
      }

      a {
        text-decoration: none;
        cursor: pointer;
        color: $rfx-bright-blue;

        &:hover {
          color: $rfx-bright-blue;
          text-decoration: underline;
        }

        &:visited {
          color: $rfx-bright-blue;
        }
      }
    }

    &__divider {
      flex: 0 0 1px;
      width: 1px;
      background-color: $rfx-light-steel;
      margin: 10px 0;
    }

    &-data-title {
      font-size: 11px;
      font-weight: bold;
      color: $rfx-shaded-grey;
      line-height: 16px;
      white-space: nowrap;
    }

    &-page-label {
      font-size: 24px;
      text-transform: uppercase;
      color: $rfx-dark-march;
    }

    &-page-title {
      opacity: .4;
      font-size: 14px;
      @include ellipsis;
    }

    &__date-button {
      outline: none;
      border: none;
      margin-top: 7px;
      text-align: initial;
      font-size: 14px;
      font-weight: 300;
      background-color: transparent;
      padding-left: 0;
      line-height: 16px;
      cursor: pointer;

      &_highlighted {
        color: $rfx-bright-blue;
      }

      &:hover {
        color: $rfx-bright-blue;
      }

      &_icon {
        align-self: auto;
      }

      &_disabled {
        pointer-events: none;
        color: $rfx-light-march;

        &:hover {
          color: $rfx-dark-march;
        }
      }
    }

    &__date-picker {
      height: 0;
      top: 60px;
      position: absolute;
      left: 0;

    }
  }

  .bottom {
    padding: 22px 30px 66px;
    background-color: #fff;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .05);
  }

</style>
